import { UUID } from '@infotech-soe/metaschema';
import { v4 as uuidv4 } from 'uuid';

import IUUIDService from './IUUIDService';

/**
 * UUID v4 generator service.
 */
class UUIDServiceSingleton implements IUUIDService {
  public generateId(): UUID {
    return uuidv4();
  }
}

const UUIDService = (() => {
  let instance: IUUIDService;
  return new Proxy(UUIDServiceSingleton, {
    construct(Target: typeof UUIDServiceSingleton): IUUIDService {
      if (!instance) {
        instance = new Target();
      }
      return instance;
    },
  });
})();

export default UUIDService;
